import { render, staticRenderFns } from "./KinDialog.vue?vue&type=template&id=5985e652"
import script from "./KinDialog.vue?vue&type=script&lang=js"
export * from "./KinDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports